const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_6329_3513)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M63.2475 0.308136C66.8683 0.308136 69.7957 3.15851 69.7957 6.85628V15.4844H65.3275V6.77925C65.3275 5.70073 64.4801 4.77628 63.3246 4.77628C62.169 4.77628 61.3216 5.62369 61.3216 6.77925V15.4074H56.8535V6.77925C56.6994 3.15851 59.6268 0.308136 63.2475 0.308136Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M71.7987 0.308136C75.4194 0.308136 78.3468 3.23554 78.3468 6.85628V15.4844H73.8787V6.77925C73.8787 5.70073 72.9542 4.77628 71.8757 4.77628C71.7987 4.77628 71.7216 4.77628 71.5676 4.77628C71.1824 3.23554 70.412 1.84888 69.3335 0.770358C70.1039 0.46221 70.9513 0.308136 71.7987 0.308136Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M86.8978 1.54074H82.4297V15.4844H86.8978V1.54074Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M96.6047 12.0178V16.717C93.4461 16.2548 90.981 13.5585 90.981 10.2459V1.54074H95.4491V10.2459C95.5261 11.0163 95.9884 11.6326 96.6047 12.0178Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M98.3765 16.64V12.0178C99.0698 11.7096 99.455 11.0163 99.455 10.2459V1.54074H104V10.2459C104 13.4815 101.612 16.2548 98.3765 16.64Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.54815 0.308136C10.1689 0.308136 13.0193 3.15851 13.0193 6.85628V15.4844H8.47407V6.77925C8.47407 5.70073 7.54963 4.77628 6.47111 4.77628C5.39259 4.85332 4.54519 5.70073 4.54519 6.77925V15.4074H0V6.77925C0 3.15851 2.92741 0.308136 6.54815 0.308136Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.0995 0.308136C18.7202 0.308136 21.6476 3.23554 21.6476 6.85628V15.4844H17.1024V6.77925C17.1024 5.70073 16.178 4.77628 15.0995 4.77628C15.0224 4.77628 14.9454 4.77628 14.8684 4.77628C14.4832 3.23554 13.7128 1.84888 12.6343 0.770358C13.4046 0.46221 14.2521 0.308136 15.0995 0.308136Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.1215 1.54074H25.6533V15.4844H30.1215V1.54074Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.905 12.0178V16.717C36.7464 16.2548 34.2812 13.5585 34.2812 10.2459V1.54074H38.7494V10.2459C38.7494 11.0163 39.2116 11.6326 39.905 12.0178Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.6772 16.64V12.0178C42.2935 11.7096 42.7558 11.0163 42.7558 10.2459V1.54074H47.2239V10.2459C47.2239 13.4815 44.8358 16.2548 41.6772 16.64Z",
  fill: "white"
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_6329_3513"
}, /*#__PURE__*/React.createElement("rect", {
  width: 104,
  height: 16.9481,
  fill: "white"
})));
function SvgMiuMiu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 17,
    viewBox: "0 0 104 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiuMiu);
export default __webpack_public_path__ + "static/media/MiuMiu.4ff5a9e2cead5325e2f53ddfe80fe9de.svg";
export { ForwardRef as ReactComponent };